import { Operation } from '../../../__generated__/globalTypes'

import {
  MinimalSponsorFragment,
  minimalSponsorFragmentString,
} from '../../fragments/__generated__/MinimalSponsorFragment'

import getSponsorRawString from '../GetSponsor.graphql'

const getSponsorString = [
  getSponsorRawString,
  minimalSponsorFragmentString,
].join('\n\n')

export type GetSponsorData = {
  sponsor: MinimalSponsorFragment
}

export type GetSponsorVariables = {
  id: string
}

export type GetSponsor = Operation<GetSponsorData, GetSponsorVariables>

export const GetSponsor = ({ id }: GetSponsorVariables): GetSponsor => ({
  query: getSponsorString,
  variables: {
    id,
  },
})
